module.exports = __webpack_public_path__ + "static/media/property_details.a088058f.png";